import React from 'react';

type EventPayload = Record<string, any>;

let queue: EventPayload[] = [];
let init = false;

window.onload = function () {
    if (window.yaCounter32628510) {
        init = true;
        queue.forEach(function (payload) {
            const event = getEvent(payload);

            window.yaCounter32628510.params(event);
        });
        queue = [];
    }
};

function getEvent(payload: EventPayload) {
    return {
        eventType: 'services_mos',
        eventSrc: 'mos.ru',
        eventDst: 'stats',
        eventTime: Date.now(),
        eventObject: {
            'zhilishniy-uche': payload,
        },
    };
}

export function triggerYaEvent(action: string, data: any = 'event') {
    if (init) {
        const event = getEvent({[action]: data});

        window.yaCounter32628510.params(event);
    } else {
        queue = [...queue, {[action]: data}];
    }
}

export function handleClickToLink(event: React.MouseEvent<HTMLAnchorElement>) {
    triggerYaEvent('Клики по ссылке', event.currentTarget.innerText);
}
